<!-- Action Toolbar Section -->
<div class="d-flex flex-wrap align-items-center gap-2 p-3">
  <div>
    <button class="btn btn-primary d-flex align-items-center gap-2 px-3 py-2 shadow-sm" data-bs-toggle="modal"
      data-bs-target="#uploadCSVModal">
      <i class="fa-solid fa-cloud-arrow-up"></i>
      <span class="d-none d-sm-inline fw-medium">Upload CSV</span>
    </button>
  </div>
  <div>
    <button class="btn btn-success d-flex align-items-center gap-2 px-3 py-2 shadow-sm" data-bs-toggle="modal"
      data-bs-target="#createAdminModal">
      <i class="fa-solid fa-plus"></i>
      <span class="d-none d-sm-inline fw-medium">New Account</span>
    </button>
  </div>
  <div class="ms-sm-auto">
    <button type="button" class="btn btn-outline-warning d-flex align-items-center gap-2 px-3 py-2 shadow-sm"
      data-bs-toggle="modal" data-bs-target="#downloadCSVModal">
      <i class="fa-regular fa-circle-down"></i>
      <span class="d-none d-sm-inline fw-medium">Download Data</span>
    </button>
  </div>
</div>

<!-- Premium Data Table Workspace Container -->
<div class="card border shadow-sm rounded-4 overflow-hidden bg-body w-100">

  <!-- Responsive Table Outer Box -->
  <div class="table-responsive m-0">
    <table class="table table-hover align-middle mb-0 transition-base">

      <!-- Table Header Structure -->
      <thead class="table-light border-bottom font-monospace small text-uppercase tracking-wider text-body-secondary">
        <tr>
          <th class="ps-4 py-3">No</th>
          <th class="py-3">Login Name</th>
          <th class="py-3">Role</th>
          <th class="py-3">Name</th>
          <th class="py-3">Title</th>
          <th class="py-3">Department</th>
          <th class="py-3">Phone</th>
          <th class="py-3">Email</th>
          <th class="py-3 text-center">Status</th>
          <th class="pe-4 py-3 text-end font-monospace fw-bold text-primary-emphasis">
            Total:
          </th>
        </tr>
      </thead>

      <!-- Table Body Container -->
      <tbody class="small text-body">
        @for (admin of admins(); track admin.adminLoginName) {
        <tr class="transition-base">
          <!-- Serial Number -->
          <td class="ps-4 font-monospace fw-semibold">{{ admin.srNo }}</td>

          <!-- Account Identifiers -->
          <td class="fw-bold text-body">
            {{ admin.adminLoginName }}
          </td>

          <!-- Security Classification Badges -->
          <td>
            <span
              class="badge rounded-pill px-2.5 py-1 text-uppercase font-monospace tracking-wide bg-info-subtle text-info-emphasis border border-info-subtle">
              {{ admin.adminRole }}
            </span>
          </td>

          <!-- User Profiles Metadata -->
          <td>{{ admin.name | titlecase }}</td>
          <td><span class="text-body-secondary">{{ admin.title || '-' }}</span></td>
          <td>{{ admin.department }}</td>
          <td class="font-monospace text-nowrap">{{ admin.phone }}</td>
          <td class="text-lowercase">{{ admin.email }}</td>

          <!-- Status Badges -->
          <td class="text-center">
            @if (admin.enabled) {
            <span
              class="badge bg-success-subtle text-success-emphasis border border-success-subtle px-2 py-1 rounded-pill d-inline-flex align-items-center gap-1">
              <i class="bi bi-check-circle-fill"></i> Active
            </span>
            } @else {
            <span
              class="badge bg-danger-subtle text-danger-emphasis border border-danger-subtle px-2 py-1 rounded-pill d-inline-flex align-items-center gap-1">
              <i class="bi bi-x-circle-fill"></i> Blocked
            </span>
            }
          </td>

          <!-- Action Buttons -->
          <td class="pe-4 text-end">
            <button class="btn btn-sm btn-icon btn-outline-secondary rounded-circle shadow-sm transition-base text-body"
              title="Edit Account Details" data-bs-toggle="modal" data-bs-target="#adminUpdate"
              (click)="AdminSingleView(admin.adminLoginName, admin)">
              <i class="bi bi-pencil"></i>
            </button>
          </td>
        </tr>
        } @empty {
        <!-- Empty Data State Placeholder Fallback Row -->
        <tr>
          <td colspan="10" class="py-5 text-body-secondary">
            <div class="d-flex flex-column align-items-center justify-content-center w-100 text-center">
              <i class="fa-regular fa-folder-open display-6 mb-3 opacity-50"></i>
              <span class="tracking-wider">No administrative profiles found.</span>
            </div>
          </td>
        </tr>
        }
      </tbody>
    </table>
  </div>
</div>

<!-- Non-blocking Top-Edge Bootstrap Progress Line -->
<!-- @if (loading()) {
<div class="position-fixed top-0 start-0 w-100 z-3" style="height: 4px;">
  <div class="progress h-100 bg-transparent rounded-0">
    <div 
      class="progress-bar progress-bar-striped progress-bar-animated bg-info w-100" 
      role="progressbar">
    </div>
  </div>
</div>
} -->

<!-- Floating Mini Card Indicator -->
@if (loading()) {
<div
  class="position-fixed bottom-0 end-0 m-2 z-3 p-3 bg-body card border-info border-opacity-25 shadow-sm d-flex flex-row align-items-center gap-2"
  style="backdrop-filter: blur(4px);">
  <!-- Mini Spinner -->
  <div class="spinner-border text-info" style="width: 1rem; height: 1rem; border-width: 2px;" role="status">
    <span class="visually-hidden">Loading...</span>
  </div>

  <!-- Text Badge Layout (Uses your global micro utilities) -->
  <div class="font-monospace text-info fw-bold tracking-widest text-uppercase pe-1 font-xs">
    Loading...
  </div>
</div>
}

<!-- ========================================== -->
<!-- CREATE ADMIN MODAL                         -->
<!-- ========================================== -->
<div class="modal fade" id="createAdminModal" tabindex="-1" aria-labelledby="createAdminModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content shadow-lg border-0 bg-body">

      <!-- Modal Header Banner Frame Layout -->
      <div class="modal-header border-bottom px-4 py-3">
        <h5 class="modal-title fw-bold text-gradient-primary" id="createAdminModalLabel">
          <i class="fa-solid fa-user-plus me-2"></i>Create Admin Login User
        </h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>

      <!-- Modal Core Input Fields Frame Body -->
      <div class="modal-body px-4 py-4">

        <!-- Wizard Step 1: Baseline Security Authorization Profile Credentials -->
        @if (isCreateAdmin()) {
        <form [formGroup]="adminLoginForm" class="d-flex flex-column gap-3">
          <div>
            <label class="form-label small fw-bold text-body-secondary mb-1.5">Login Username Name</label>
            <input type="text" class="form-control shadow-sm" formControlName="username"
              placeholder="Set username min length 5" />
          </div>
          <div>
            <label class="form-label small fw-bold text-body-secondary mb-1.5">Login Username Role</label>
            <select formControlName="role" class="form-select shadow-sm">
              <option value="" disabled selected>Choose admin role level...</option>
              @for (option of roleOptions; track option) {
              <option [value]="option">{{ option }}</option>
              }
            </select>
          </div>
        </form>
        }

        <!-- Wizard Step 2: Extended Employee Profile Metadata Parameters -->
        @if (!isCreateAdmin()) {
        <form [formGroup]="registerAdminForm" class="row g-3">
          <div class="col-12">
            <label class="form-label small fw-bold text-body-secondary mb-1.5">Full Name</label>
            <input type="text" class="form-control shadow-sm" formControlName="name" placeholder="Set admin name" />
          </div>
          <div class="col-md-6">
            <label class="form-label small fw-bold text-body-secondary mb-1.5">Designation Title</label>
            <input type="text" class="form-control shadow-sm" formControlName="title" placeholder="Set admin title" />
          </div>
          <div class="col-md-6">
            <label class="form-label small fw-bold text-body-secondary mb-1.5">Department</label>
            <input type="text" class="form-control shadow-sm" formControlName="department"
              placeholder="Set admin department" />
          </div>
          <div class="col-12">
            <label class="form-label small fw-bold text-body-secondary mb-1.5">Primary Contact Phone Number</label>
            <input type="tel" class="form-control shadow-sm font-monospace" formControlName="phone" placeholder="959" />
          </div>
          <div class="col-12">
            <label class="form-label small fw-bold text-body-secondary mb-1.5">Official Identity Email</label>
            <input type="email" class="form-control shadow-sm text-lowercase" formControlName="email"
              placeholder="a@gmail.com" />
          </div>
        </form>
        }

        <!-- Runtime Execution API Fault Warning Banners -->
        @if (isError()) {
        <div
          class="alert alert-danger d-flex align-items-center gap-2 mt-4 mb-0 py-2.5 border-0 shadow-sm font-monospace small"
          role="alert">
          <i class="fa-solid fa-circle-exclamation fs-5 text-danger"></i>
          <div>{{ errorMessage() }}</div>
        </div>
        }
      </div>

      <!-- Modal Operational Command Buttons Group Footer -->
      <div class="modal-footer border-top px-4 py-2.5">
        <button type="button" class="btn btn-sm btn-secondary opacity-75 shadow-sm px-3 py-1.5 fw-medium"
          data-bs-dismiss="modal">Close</button>

        <!-- Step 1 Trigger Command -->
        @if (isCreateAdmin()) {
        <button type="button"
          class="btn btn-sm btn-primary px-4 py-1.5 shadow-sm fw-bold d-inline-flex align-items-center gap-2"
          (click)="createAdmin()" [disabled]="!adminLoginForm.valid || apiLoading()">
          @if (apiLoading()) {
          <span class="spinner-border spinner-border-sm" role="status"></span>
          } @else {
          <span>Next Step <i class="fa-solid fa-chevron-right font-xs"></i></span>
          }
        </button>
        }

        <!-- Step 2 Trigger Command -->
        @if (!isCreateAdmin()) {
        <button type="button"
          class="btn btn-sm btn-success px-4 py-1.5 shadow-sm fw-bold d-inline-flex align-items-center gap-2"
          (click)="registerAdmin()" [disabled]="!registerAdminForm.valid || apiLoading()">
          @if (apiLoading()) {
          <span class="spinner-border spinner-border-sm" role="status"></span>
          } @else {
          <span>Submit Account <i class="fa-solid fa-cloud-arrow-up font-xs"></i></span>
          }
        </button>
        }
      </div>

    </div>
  </div>
</div>


<!-- ========================================== -->
<!-- UPDATE ADMIN MODAL                         -->
<!-- ========================================== -->
<div class="modal fade" id="adminUpdate" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content shadow-lg border-0 bg-body">

      <!-- Modal Header Banner Layout -->
      <div class="modal-header border-bottom px-4 py-3">
        <h5 class="modal-title fw-bold text-gradient-primary">
          <i class="fa-solid fa-user-gear me-2"></i>Manage Core Profile
        </h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>

      <!-- Modal Core Content Workspace -->
      <div class="modal-body px-4 py-4">
        <form [formGroup]="adminDataForm" class="d-flex flex-column gap-3">

          <!-- Unified Grid-Aligned Input Pairs -->
          <div class="row align-items-center g-2">
            <div class="col-4 col-md-3 small fw-bold text-body-secondary">Full Name</div>
            <div class="col-8 col-md-9">
              <input type="text" class="form-control shadow-sm" formControlName="name" />
            </div>
          </div>

          <div class="row align-items-center g-2">
            <div class="col-4 col-md-3 small fw-bold text-body-secondary">Designation Title</div>
            <div class="col-8 col-md-9">
              <input type="text" class="form-control shadow-sm" formControlName="title" />
            </div>
          </div>

          <div class="row align-items-center g-2">
            <div class="col-4 col-md-3 small fw-bold text-body-secondary">Department</div>
            <div class="col-8 col-md-9">
              <input type="text" class="form-control shadow-sm" formControlName="department" />
            </div>
          </div>

          <div class="row align-items-center g-2">
            <div class="col-4 col-md-3 small fw-bold text-body-secondary">Phone Line</div>
            <div class="col-8 col-md-9">
              <input type="text" class="form-control shadow-sm font-monospace" formControlName="phone" />
            </div>
          </div>

          <div class="row align-items-center g-2">
            <div class="col-4 col-md-3 small fw-bold text-body-secondary">Email Address</div>
            <div class="col-8 col-md-9">
              <input type="text" class="form-control shadow-sm text-lowercase" formControlName="email" />
            </div>
          </div>

          <!-- Form Dispatch Row Action -->
          <div class="row g-2 mt-2">
            <div class="col-4 col-md-3"></div>
            <div class="col-8 col-md-9">
              <button type="button"
                class="btn btn-sm btn-primary px-4 py-2 shadow-sm w-100 d-inline-flex align-items-center justify-content-center gap-2 fw-semibold"
                [disabled]="!adminDataForm.valid || apiLoading()" (click)="UpdateAdminData()">
                @if (apiLoading()) {
                <span class="spinner-border spinner-border-sm" role="status"></span>
                } @else {
                <span>Save Data Changes <i class="fa-solid fa-floppy-disk"></i></span>
                }
              </button>
            </div>
          </div>
        </form>

        <!-- Dynamically Inserted Server Response Container Block -->
        @if (htmlstring) {
        <div class="mt-3 transition-base" [innerHTML]="htmlstring"></div>
        }
      </div>

      <!-- Governance and Access Override Commands Layout Footer -->
      <div class="modal-footer justify-content-between border-top px-4 py-2.5 flex-wrap gap-2">
        <div class="d-flex align-items-center gap-2 flex-wrap">
          <!-- Password Lifecycle Modifier -->
          <button class="btn btn-sm btn-outline-info d-inline-flex align-items-center gap-1.5 shadow-sm fw-medium px-3"
            [disabled]="apiLoading()" (click)="ResetAdminPassword()">
            <i class="fa-solid fa-key"></i> Reset password
          </button>

          <!-- System Access Status Multi-Toggles -->
          @if (!loginEnableStatus()) {
          <button class="btn btn-sm btn-success d-inline-flex align-items-center gap-1.5 shadow-sm fw-medium px-3"
            [disabled]="apiLoading()" (click)="AdminLoginEnable()">
            <i class="fa-solid fa-user-check"></i> Login enable
          </button>
          }
          @if (loginEnableStatus()) {
          <button class="btn btn-sm btn-danger d-inline-flex align-items-center gap-1.5 shadow-sm fw-medium px-3"
            [disabled]="apiLoading()" (click)="AdminLoginDisable()">
            <i class="fa-solid fa-user-slash"></i> Login disable
          </button>
          }
        </div>
        <button type="button" class="btn btn-sm btn-warning shadow-sm px-3 py-1.5 fw-medium"
          data-bs-dismiss="modal">Close</button>
      </div>

    </div>
  </div>
</div>


<!-- ========================================== -->
<!-- CSV UPLOAD MODAL CONTAINER                 -->
<!-- ========================================== -->
<div class="modal fade" id="uploadCSVModal" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content shadow-lg border-0 bg-body">

      <!-- Modal Header -->
      <div class="modal-header border-bottom px-4 py-3">
        <h5 class="modal-title fw-bold text-gradient-primary">
          <i class="fa-solid fa-file-csv me-2"></i>Admin Upload CSV File
        </h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>

      <!-- Modal Body -->
      <div class="modal-body px-4 py-4">
        <div class="mb-0">
          <label class="form-label small fw-bold text-body-secondary mb-2">
            Select Local CSV Data Spreadsheet Source
          </label>

          <div class="input-group shadow-sm rounded">
            <input type="file" class="form-control file-input" enctype="multipart/form-data" accept=".csv"
              (change)="onFileSelected($event)" />
          </div>

          <div class="form-text font-monospace font-xs mt-2 text-body-secondary">
            * Please verify the file contains headers matching our current user profile database schema structure.
          </div>
        </div>

        <!-- Functional API Error Banner Node -->
        @if (isUploadError()) {
        <div
          class="alert alert-danger d-flex align-items-center gap-2 mt-4 mb-0 py-2.5 border-0 shadow-sm font-monospace small"
          role="alert">
          <i class="fa-solid fa-circle-exclamation fs-5 text-danger"></i>
          <div>{{ errorMessage() }}</div>
        </div>
        }
      </div>

      <!-- Modal Footer Controls Grid -->
      <div class="modal-footer border-top px-4 py-2.5">
        <button type="button" class="btn btn-sm btn-secondary opacity-75 shadow-sm px-3 py-1.5 fw-medium"
          data-bs-dismiss="modal">Close</button>
        <button type="button"
          class="btn btn-sm btn-primary px-4 py-1.5 shadow-sm fw-bold d-inline-flex align-items-center gap-2"
          (click)="uploadFile()" [disabled]="apiLoading()">
          @if (apiLoading()) {
          <span class="spinner-border spinner-border-sm" role="status"></span>
          } @else {
          <span>Submit <i class="fa-solid fa-cloud-arrow-up font-xs"></i></span>
          }
        </button>
      </div>

    </div>
  </div>
</div>

<!-- ========================================== -->
<!-- RECONCILIATION DOWNLOAD MODAL LAYER        -->
<!-- ========================================== -->
<div class="modal fade" id="downloadCSVModal" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content shadow-lg border-0 bg-body">

      <!-- Modal Header -->
      <div class="modal-header border-bottom px-4 py-3">
        <h5 class="modal-title fw-bold text-gradient-primary">
          <i class="fa-solid fa-download me-2"></i>Admin Download CSV File
        </h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>

      <!-- Modal Body -->
      <div class="modal-body px-4 py-4">
        <div class="mb-0">
          <label class="form-label small fw-bold text-body-secondary mb-2">
            Export Target Document Filename Configuration
          </label>

          <div class="input-group shadow-sm rounded">
            <span class="input-group-text border">
              <i class="fa-solid fa-file-signature text-muted"></i>
            </span>
            <input type="text" class="form-control" placeholder="Enter file name (e.g., admin_report_2026)"
              [(ngModel)]="downloadFileName" />
            <span class="input-group-text border font-monospace small">
              .csv
            </span>
          </div>
        </div>
      </div>

      <!-- Modal Footer Controls Grid -->
      <div class="modal-footer border-top px-4 py-2.5">
        <button type="button" class="btn btn-sm btn-secondary opacity-75 shadow-sm px-3 py-1.5 fw-medium"
          data-bs-dismiss="modal">Close</button>
        <button type="button"
          class="btn btn-sm btn-success px-4 py-1.5 shadow-sm fw-bold d-inline-flex align-items-center gap-2"
          (click)="downloadFile()" [disabled]="!downloadFileName || isDownloading()">
          @if (isDownloading()) {
          <span class="spinner-border spinner-border-sm" role="status"></span>
          } @else {
          <span>Extract Matrix <i class="fa-solid fa-circle-down font-xs"></i></span>
          }
        </button>
      </div>

    </div>
  </div>
</div>